import React from 'react';
import { Modal } from 'react-bootstrap';

type MailVerifyFormProps = {
  show: boolean;
  handleClose: () => void;
};

const MailVerifyForm: React.FC<MailVerifyFormProps> = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Email Verification Required</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Please verify your email address before logging in. Check your inbox for a verification email and follow the instructions to verify your email.
      </Modal.Body>
    </Modal>
  );
};

export default MailVerifyForm;
